export const abi = [
	{
		type: 'constructor',
		inputs: [
			{ name: '_claimStartBlock', type: 'uint256', internalType: 'uint256' },
			{ name: '_tokenName', type: 'string', internalType: 'string' },
			{ name: '_tokenSymbol', type: 'string', internalType: 'string' },
			{ name: 'initialValidators', type: 'address[]', internalType: 'address[]' }
		],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'CHZStakedRewards',
		inputs: [],
		outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'DEFAULT_ADMIN_ROLE',
		inputs: [],
		outputs: [{ name: '', type: 'bytes32', internalType: 'bytes32' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'EPOCH_LENGTH',
		inputs: [],
		outputs: [{ name: '', type: 'uint16', internalType: 'uint16' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'MAX_SUPPLY',
		inputs: [],
		outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'MINTER_ROLE',
		inputs: [],
		outputs: [{ name: '', type: 'bytes32', internalType: 'bytes32' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'MINT_LIMIT',
		inputs: [],
		outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'addMinter',
		inputs: [{ name: 'minter', type: 'address', internalType: 'address' }],
		outputs: [],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'addValidator',
		inputs: [{ name: 'validator', type: 'address', internalType: 'address' }],
		outputs: [],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'allowance',
		inputs: [
			{ name: 'owner', type: 'address', internalType: 'address' },
			{ name: 'spender', type: 'address', internalType: 'address' }
		],
		outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'approve',
		inputs: [
			{ name: 'spender', type: 'address', internalType: 'address' },
			{ name: 'amount', type: 'uint256', internalType: 'uint256' }
		],
		outputs: [{ name: '', type: 'bool', internalType: 'bool' }],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'balanceOf',
		inputs: [{ name: 'account', type: 'address', internalType: 'address' }],
		outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'burn',
		inputs: [{ name: 'amount', type: 'uint256', internalType: 'uint256' }],
		outputs: [],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'calculateRewards',
		inputs: [{ name: 'account', type: 'address', internalType: 'address' }],
		outputs: [
			{ name: 'rewardStakingPoolAmount', type: 'uint256', internalType: 'uint256' },
			{ name: 'rewardStakingAmount', type: 'uint256', internalType: 'uint256' }
		],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'calculateRewards2',
		inputs: [{ name: 'account', type: 'address', internalType: 'address' }],
		outputs: [
			{ name: 'rewardStakingPoolAmount', type: 'uint256', internalType: 'uint256' },
			{ name: 'rewardStakingAmount', type: 'uint256', internalType: 'uint256' }
		],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'cap',
		inputs: [],
		outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'changeClaimStartBlock',
		inputs: [{ name: 'newStartBlock', type: 'uint256', internalType: 'uint256' }],
		outputs: [],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'changeMinimumCHZStakedAmount',
		inputs: [{ name: 'chzAmount', type: 'uint256', internalType: 'uint256' }],
		outputs: [],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'changeRewardsCHZStakedAmount',
		inputs: [{ name: 'pepperAmount', type: 'uint256', internalType: 'uint256' }],
		outputs: [],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'changeStakingContract',
		inputs: [{ name: 'newStakingContract', type: 'address', internalType: 'address' }],
		outputs: [],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'changeStakingPoolContract',
		inputs: [{ name: 'newStakingPoolContract', type: 'address', internalType: 'address' }],
		outputs: [],
		stateMutability: 'nonpayable'
	},
	{ type: 'function', name: 'claim', inputs: [], outputs: [], stateMutability: 'nonpayable' },
	{ type: 'function', name: 'claim2', inputs: [], outputs: [], stateMutability: 'nonpayable' },
	{
		type: 'function',
		name: 'claimEnabled',
		inputs: [],
		outputs: [{ name: '', type: 'bool', internalType: 'bool' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'claimStartBlock',
		inputs: [],
		outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'claims',
		inputs: [
			{ name: '', type: 'address', internalType: 'address' },
			{ name: '', type: 'uint256', internalType: 'uint256' }
		],
		outputs: [
			{ name: 'amountStakingPoolClaimed', type: 'uint256', internalType: 'uint256' },
			{ name: 'amountStakingClaimed', type: 'uint256', internalType: 'uint256' },
			{ name: 'blockNumber', type: 'uint256', internalType: 'uint256' }
		],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'decimals',
		inputs: [],
		outputs: [{ name: '', type: 'uint8', internalType: 'uint8' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'decreaseAllowance',
		inputs: [
			{ name: 'spender', type: 'address', internalType: 'address' },
			{ name: 'subtractedValue', type: 'uint256', internalType: 'uint256' }
		],
		outputs: [{ name: '', type: 'bool', internalType: 'bool' }],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'getClaimStatus',
		inputs: [],
		outputs: [{ name: '', type: 'bool', internalType: 'bool' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'getCurrentEpoch',
		inputs: [],
		outputs: [{ name: '_epoch', type: 'uint256', internalType: 'uint256' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'getNumberOfValidators',
		inputs: [],
		outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'getPendingClaim',
		inputs: [],
		outputs: [{ name: 'pendingHarvest', type: 'uint256', internalType: 'uint256' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'getPendingClaim2',
		inputs: [],
		outputs: [{ name: 'pendingHarvest', type: 'uint256', internalType: 'uint256' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'getRoleAdmin',
		inputs: [{ name: 'role', type: 'bytes32', internalType: 'bytes32' }],
		outputs: [{ name: '', type: 'bytes32', internalType: 'bytes32' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'getValidators',
		inputs: [],
		outputs: [{ name: '', type: 'address[]', internalType: 'address[]' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'grantRole',
		inputs: [
			{ name: 'role', type: 'bytes32', internalType: 'bytes32' },
			{ name: 'account', type: 'address', internalType: 'address' }
		],
		outputs: [],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'hasRole',
		inputs: [
			{ name: 'role', type: 'bytes32', internalType: 'bytes32' },
			{ name: 'account', type: 'address', internalType: 'address' }
		],
		outputs: [{ name: '', type: 'bool', internalType: 'bool' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'increaseAllowance',
		inputs: [
			{ name: 'spender', type: 'address', internalType: 'address' },
			{ name: 'addedValue', type: 'uint256', internalType: 'uint256' }
		],
		outputs: [{ name: '', type: 'bool', internalType: 'bool' }],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'isValidator',
		inputs: [{ name: 'validator', type: 'address', internalType: 'address' }],
		outputs: [{ name: '', type: 'bool', internalType: 'bool' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'minCHZStaked',
		inputs: [],
		outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'mint',
		inputs: [
			{ name: 'to', type: 'address', internalType: 'address' },
			{ name: 'amount', type: 'uint256', internalType: 'uint256' }
		],
		outputs: [],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'minterRoleMintedAmount',
		inputs: [],
		outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'name',
		inputs: [],
		outputs: [{ name: '', type: 'string', internalType: 'string' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'owner',
		inputs: [],
		outputs: [{ name: '', type: 'address', internalType: 'address' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'removeMinter',
		inputs: [{ name: 'minter', type: 'address', internalType: 'address' }],
		outputs: [],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'removeValidator',
		inputs: [{ name: 'validator', type: 'address', internalType: 'address' }],
		outputs: [],
		stateMutability: 'nonpayable'
	},
	{ type: 'function', name: 'renounceOwnership', inputs: [], outputs: [], stateMutability: 'nonpayable' },
	{
		type: 'function',
		name: 'renounceRole',
		inputs: [
			{ name: 'role', type: 'bytes32', internalType: 'bytes32' },
			{ name: 'account', type: 'address', internalType: 'address' }
		],
		outputs: [],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'revokeRole',
		inputs: [
			{ name: 'role', type: 'bytes32', internalType: 'bytes32' },
			{ name: 'account', type: 'address', internalType: 'address' }
		],
		outputs: [],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'setClaimEnabled',
		inputs: [{ name: 'enabled', type: 'bool', internalType: 'bool' }],
		outputs: [],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'stakingContract',
		inputs: [],
		outputs: [{ name: '', type: 'address', internalType: 'contract IStaking' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'stakingPoolContract',
		inputs: [],
		outputs: [{ name: '', type: 'address', internalType: 'contract IStakingPool' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'supportsInterface',
		inputs: [{ name: 'interfaceId', type: 'bytes4', internalType: 'bytes4' }],
		outputs: [{ name: '', type: 'bool', internalType: 'bool' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'symbol',
		inputs: [],
		outputs: [{ name: '', type: 'string', internalType: 'string' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'totalSupply',
		inputs: [],
		outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
		stateMutability: 'view'
	},
	{
		type: 'function',
		name: 'transfer',
		inputs: [
			{ name: 'to', type: 'address', internalType: 'address' },
			{ name: 'amount', type: 'uint256', internalType: 'uint256' }
		],
		outputs: [{ name: '', type: 'bool', internalType: 'bool' }],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'transferFrom',
		inputs: [
			{ name: 'from', type: 'address', internalType: 'address' },
			{ name: 'to', type: 'address', internalType: 'address' },
			{ name: 'amount', type: 'uint256', internalType: 'uint256' }
		],
		outputs: [{ name: '', type: 'bool', internalType: 'bool' }],
		stateMutability: 'nonpayable'
	},
	{
		type: 'function',
		name: 'transferOwnership',
		inputs: [{ name: 'newOwner', type: 'address', internalType: 'address' }],
		outputs: [],
		stateMutability: 'nonpayable'
	},
	{
		type: 'event',
		name: 'Approval',
		inputs: [
			{ name: 'owner', type: 'address', indexed: true, internalType: 'address' },
			{ name: 'spender', type: 'address', indexed: true, internalType: 'address' },
			{ name: 'value', type: 'uint256', indexed: false, internalType: 'uint256' }
		],
		anonymous: false
	},
	{
		type: 'event',
		name: 'ClaimEnabledStatusChanged',
		inputs: [{ name: 'status', type: 'bool', indexed: true, internalType: 'bool' }],
		anonymous: false
	},
	{
		type: 'event',
		name: 'ClaimStartBlockChanged',
		inputs: [{ name: 'newStartBlock', type: 'uint256', indexed: true, internalType: 'uint256' }],
		anonymous: false
	},
	{
		type: 'event',
		name: 'Claimed',
		inputs: [
			{ name: 'account', type: 'address', indexed: true, internalType: 'address' },
			{ name: 'amountStakingPool', type: 'uint256', indexed: true, internalType: 'uint256' },
			{ name: 'amountStaking', type: 'uint256', indexed: true, internalType: 'uint256' }
		],
		anonymous: false
	},
	{
		type: 'event',
		name: 'EpochLengthChanged',
		inputs: [{ name: 'epochLength', type: 'uint16', indexed: true, internalType: 'uint16' }],
		anonymous: false
	},
	{
		type: 'event',
		name: 'MinimumCHZStakedAmountChanged',
		inputs: [{ name: 'chzAmount', type: 'uint256', indexed: true, internalType: 'uint256' }],
		anonymous: false
	},
	{
		type: 'event',
		name: 'OwnershipTransferred',
		inputs: [
			{ name: 'previousOwner', type: 'address', indexed: true, internalType: 'address' },
			{ name: 'newOwner', type: 'address', indexed: true, internalType: 'address' }
		],
		anonymous: false
	},
	{
		type: 'event',
		name: 'RewardsCHZStakedAmountChanged',
		inputs: [{ name: 'pepperAmount', type: 'uint256', indexed: true, internalType: 'uint256' }],
		anonymous: false
	},
	{
		type: 'event',
		name: 'RoleAdminChanged',
		inputs: [
			{ name: 'role', type: 'bytes32', indexed: true, internalType: 'bytes32' },
			{ name: 'previousAdminRole', type: 'bytes32', indexed: true, internalType: 'bytes32' },
			{ name: 'newAdminRole', type: 'bytes32', indexed: true, internalType: 'bytes32' }
		],
		anonymous: false
	},
	{
		type: 'event',
		name: 'RoleGranted',
		inputs: [
			{ name: 'role', type: 'bytes32', indexed: true, internalType: 'bytes32' },
			{ name: 'account', type: 'address', indexed: true, internalType: 'address' },
			{ name: 'sender', type: 'address', indexed: true, internalType: 'address' }
		],
		anonymous: false
	},
	{
		type: 'event',
		name: 'RoleRevoked',
		inputs: [
			{ name: 'role', type: 'bytes32', indexed: true, internalType: 'bytes32' },
			{ name: 'account', type: 'address', indexed: true, internalType: 'address' },
			{ name: 'sender', type: 'address', indexed: true, internalType: 'address' }
		],
		anonymous: false
	},
	{
		type: 'event',
		name: 'StakingContractChanged',
		inputs: [{ name: 'newStakingContract', type: 'address', indexed: true, internalType: 'address' }],
		anonymous: false
	},
	{
		type: 'event',
		name: 'StakingPoolContractChanged',
		inputs: [{ name: 'newStakingPoolContract', type: 'address', indexed: true, internalType: 'address' }],
		anonymous: false
	},
	{
		type: 'event',
		name: 'Transfer',
		inputs: [
			{ name: 'from', type: 'address', indexed: true, internalType: 'address' },
			{ name: 'to', type: 'address', indexed: true, internalType: 'address' },
			{ name: 'value', type: 'uint256', indexed: false, internalType: 'uint256' }
		],
		anonymous: false
	}
] as const
